import { SESSION_TYPE } from "modules/Booking/common/constants"

export function paymentButtonText(
    sessionType: SESSION_TYPE,
    onlyFree: boolean,
    skipPayment: boolean,
    isAutoPay: boolean
) {
    if (sessionType === SESSION_TYPE.DEPOSIT) {
        return "Оплатить абонемент"
    }

    if (onlyFree || skipPayment) {
        return "Записаться"
    } else {
        return isAutoPay ? "Оплатить" : "Перейти к оплате"
    }
}
